import { NonEmptyArray } from './utilityTypes';

type ExecutionStatus = { succeeded: boolean };

type ErrorHandler<R> = (e: Error) => R;

type ErrorHandlerOrValue<R> = ErrorHandler<R> | R;

const returnOrCall = <R>(
    handlerOrValue: ErrorHandlerOrValue<R>,
    error: Error
): R =>
    handlerOrValue instanceof Function ? handlerOrValue(error) : handlerOrValue;

/* eslint @typescript-eslint/ban-types: 0 */
const errorHandler = <R>(
    handlerOrValue: ErrorHandlerOrValue<R>,
    ...errorTypes: NonEmptyArray<Function>
): ErrorHandler<R> => {
    return error => {
        if (errorTypes.some(e => error instanceof e)) {
            return returnOrCall(handlerOrValue, error);
        }
        throw error;
    };
};

const buildExecutionStatus = (succeeded: boolean) => ({ succeeded });
const succeeded = (): ExecutionStatus => buildExecutionStatus(true);
const failed = (): ExecutionStatus => buildExecutionStatus(false);

class RuntimeAssertionError extends Error {
    constructor(value: unknown) {
        super(
            `Reaching this code part is not expected. Value that raised the exception: ${value}`
        );
    }
}

function assertUnreachable(x: never): never {
    throw new RuntimeAssertionError(x);
}

export {
    assertUnreachable,
    errorHandler,
    failed,
    returnOrCall,
    RuntimeAssertionError,
    succeeded,
};
export type { ErrorHandler, ExecutionStatus };
